<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner5.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">产品中心</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('WuLianWangChanPin')">物联网产品</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('JiFangHuanJingZiDongJianKongXiTong')">机房环境自动监控系统</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('XinFangYiTiJi')">信访一体机</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('RuanJianChanPin')">软件产品</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YingJianChanPin')">硬件产品</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <div id="product_list">
                        <ul>
                            <li>
                                <div class="album" v-for="(article, index) in article_list" :key="index" :id="article.id">
                                    <div class="div">
                                        <a href="javascript:void(0);" @click.stop="article_view(article.id)">
                                            <span class="pic"><img :src="img_address+article.contentImg" :onerror="defaultImg" /></span>
                                            <span class="title">{{ article.contentTitle }}<i class="icon icon_more"></i></span>
                                            <span class="text">{{ article.contentDescription }}</span>
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="page">
                        <span>总共 {{ total_page }} 页，当前第 {{ pageNum }} 页</span>
                        <a href="javascript:void(0);" @click.stop="page('first')">首页</a>
                        <a href="javascript:void(0);" @click.stop="page('pre')" v-if="page_pre == 1">上一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">上一页</a>
                        <a href="javascript:void(0);" @click.stop="page('next')" v-if="page_next == 1">下一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">下一页</a>
                        <a href="javascript:void(0);" @click.stop="page('last')">尾页</a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { ChanPinZhongXin } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '物联网产品',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            article_list: '',

            img_address:'http://www.corner.com.cn',

            defaultImg: 'this.src="' + require('../assets/img/default.jpg') + '"',

            contentType : 303,

            //翻页
            pageNum: 1, //当前页
            pageSize: 6, //每页显示数
            total : 0, //总数据

            total_page : '', //总页数
            page_pre : 0, //上一页
            page_next : 0, //下一页
            
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.ChanPinZhongXin_data( this.contentType, this.pageNum, this.pageSize );
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        article_view( id ) {  //带uuid跳转详情页面
            this.$router.push({
                path: "ProductView",
                query: { id: id },
            });
        },
        page(e) {
            //分页参数
            if( e == "first" ){
                //首页
                this.ChanPinZhongXin_data(
                    this.contentType,
                    1,
                    this.pageSize,
                );
            } else if ( e == "pre" ) {
                //上一页
                this.ChanPinZhongXin_data(
                    this.contentType,
                    this.pageNum - 1,
                    this.pageSize,
                );
            } else if ( e == "next" ) {
                //下一页
                this.ChanPinZhongXin_data(
                    this.contentType,
                    this.pageNum + 1,
                    this.pageSize,
                );
            } else if( e == "last" ){
                //尾页
                this.ChanPinZhongXin_data(
                    this.contentType,
                    this.total_page,
                    this.pageSize,
                );
            };
        },
        ChanPinZhongXin_data( contentType, pageNum, pageSize ){ //文章分类显示

            ChanPinZhongXin({
                contentType : contentType , //分类
                pageNum : pageNum, //当前是第几页
                pageSize : pageSize, //每页显示多少条
            }).then((res) => {
                console.log( res );
                this.article_list = res.rows;

                //翻页
                this.pageNum = pageNum; //当前页
                this.total = res.total; //总数据

                this.total_page = Math.ceil( res.total / this.pageSize );

                if( this.pageNum < this.total_page && this.pageNum == 1){
                    this.page_pre = 0;
                    this.page_next = 1;
                } else if ( this.pageNum == this.total_page && this.pageNum !== 1 ) {
                    this.page_pre = 1;
                    this.page_next = 0;
                } else if ( this.pageNum == this.total_page && this.total_page == 1 ) {
                    this.page_pre = 0;
                    this.page_next = 0;
                }else{
                    this.page_pre = 1;
                    this.page_next = 1;
                };

            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/WuLianWangChanPin.vue